import { TestSegmentProps, AudioDataProps } from "../types";

// const data: AudioDataProps = {
//   //------> use testSegments data to set segment state
//   audioUrl: "EOS-test.mp3",
//   audioContentType: "audio/mpeg",
//   waveformDataUrl: "EOS-test.dat",
// };
export const audioData: AudioDataProps = {
  //------> use testSegmentsSmall data set to set segment state
  audioUrl: "instrumental.mp3",
  audioContentType: "audio/mpeg",
  waveformDataUrl: "instrumental.dat",
};

export const testSegmentsSmall: TestSegmentProps[] = [
  {
    id: "4",
    fileName: "Segment-5",
    startTime: 77,
    endTime: 90,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-5",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "2",
    fileName: "Segment-3",
    startTime: 45,
    endTime: 60,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-3",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "5",
    fileName: "Segment-6",
    startTime: 106,
    endTime: 110,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-6",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "3",
    fileName: "Segment-4",
    startTime: 70,
    endTime: 75,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-4",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "0",
    fileName: "Segment-1",
    startTime: 10,
    endTime: 15,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-1",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "1",
    fileName: "Segment-2",
    startTime: 20,
    endTime: 40,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-2",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
];

export const testSegments: TestSegmentProps[] = [
  {
    id: "0",
    fileName: "Segment-1",
    startTime: 100,
    endTime: 360,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-1",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "1",
    fileName: "Segment-2",
    startTime: 366,
    endTime: 371,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-2",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "2",
    fileName: "Segment-3",
    startTime: 372,
    endTime: 377,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-3",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "3",
    fileName: "Segment-4",
    startTime: 528,
    endTime: 750,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-4",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "4",
    fileName: "Segment-5",
    startTime: 789,
    endTime: 794,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-5",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "5",
    fileName: "Segment-6",
    startTime: 1044,
    endTime: 1200,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-6",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "6",
    fileName: "Segment-7",
    startTime: 1484,
    endTime: 1489,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-7",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "7",
    fileName: "Segment-8",
    startTime: 1806,
    endTime: 2500,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-8",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "8",
    fileName: "Segment-9",
    startTime: 3101,
    endTime: 3500,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-9",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "9",
    fileName: "Segment-10",
    startTime: 3746,
    endTime: 4300,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-10",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "10",
    fileName: "Segment-11",
    startTime: 4618,
    endTime: 5223,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-11",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
  {
    id: "11",
    fileName: "Segment-12",
    startTime: 5474,
    endTime: 5600,
    editable: true,
    color: "#1E1541",
    labelText: "Segment-12",
    formErrors: {
      fileNameError: false,
      isCreated: false,
    },
  },
];
